(function () {
  'use strict';

  /*
   * ==========================================================
   * SAINT CBD — CARROUSEL 3D INFINI
   *
   * Compatible :
   * - plusieurs collections sur une page
   * - Shopify Theme Editor
   * - swipe tactile
   * - glisser souris
   * - flèches
   * - boucle infinie
   * ==========================================================
   */

  if (window.SaintCBDInfinite3D) {
    window.SaintCBDInfinite3D.mountAll(document);
    return;
  }

  var API = {};
  var SELECTOR = '[data-sc-section]';

  var states = new WeakMap();


  function arrayFrom(list) {
    return Array.prototype.slice.call(list || []);
  }


  function modulo(value, total) {
    return ((value % total) + total) % total;
  }


  function refreshState(root) {

    var state = states.get(root);

    if (!state) {

      state = {
        root: root,

        shell: null,
        wheel: null,
        items: [],

        prevButton: null,
        nextButton: null,

        active: 0,

        active3D: false,

        animating: false,

        pointerId: null,

        startX: 0,
        startY: 0,

        lastX: 0,
        lastY: 0
      };

      states.set(root, state);
    }


    state.shell =
      root.querySelector('[data-sc-shell]');


    state.wheel =
      root.querySelector('[data-sc-wheel]');


    state.items =
      arrayFrom(
        root.querySelectorAll('[data-sc-item]')
      );


    state.prevButton =
      root.querySelector('[data-sc-prev]');


    state.nextButton =
      root.querySelector('[data-sc-next]');


    if (
      state.active >=
      state.items.length
    ) {
      state.active = 0;
    }


    return state;
  }


  function isMobile(root) {

    var rootWidth =
      root.getBoundingClientRect().width;

    var viewport =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      9999;


    return (
      viewport <= 820 ||
      rootWidth <= 820
    );
  }


  function wheelEnabled(root) {

    return (
      root.getAttribute(
        'data-mobile-3d'
      ) === 'true'
    );
  }


  function relativePosition(
    state,
    index
  ) {

    var total =
      state.items.length;

    var difference =
      index - state.active;


    while (
      difference >
      total / 2
    ) {

      difference -= total;
    }


    while (
      difference <
      -total / 2
    ) {

      difference += total;
    }


    return difference;
  }


  function removePositionClasses(item) {

    item.classList.remove(
      'sc-center',
      'sc-left',
      'sc-right',
      'sc-far-left',
      'sc-far-right',
      'sc-hidden'
    );
  }


  function render(state) {

    if (
      !state ||
      !state.items.length
    ) {
      return;
    }


    state.items.forEach(
      function (item, index) {

        removePositionClasses(item);


        var position =
          relativePosition(
            state,
            index
          );


        if (position === 0) {

          item.classList.add(
            'sc-center'
          );

          item.setAttribute(
            'aria-hidden',
            'false'
          );

        }


        else if (
          position === -1
        ) {

          item.classList.add(
            'sc-left'
          );

          item.setAttribute(
            'aria-hidden',
            'true'
          );

        }


        else if (
          position === 1
        ) {

          item.classList.add(
            'sc-right'
          );

          item.setAttribute(
            'aria-hidden',
            'true'
          );

        }


        else if (
          position === -2
        ) {

          item.classList.add(
            'sc-far-left'
          );

          item.setAttribute(
            'aria-hidden',
            'true'
          );

        }


        else if (
          position === 2
        ) {

          item.classList.add(
            'sc-far-right'
          );

          item.setAttribute(
            'aria-hidden',
            'true'
          );

        }


        else {

          item.classList.add(
            'sc-hidden'
          );

          item.setAttribute(
            'aria-hidden',
            'true'
          );

        }

      }
    );
  }


  function measure(state) {

    if (
      !state.active3D ||
      !state.wheel
    ) {
      return;
    }


    requestAnimationFrame(
      function () {

        var maxHeight = 0;


        state.items.forEach(
          function (item) {

            item.style.height =
              'auto';


            var card =
              item.querySelector(
                '.sc-card'
              );


            if (!card) {
              return;
            }


            maxHeight =
              Math.max(
                maxHeight,
                card.offsetHeight,
                card.scrollHeight
              );
          }
        );


        if (maxHeight <= 0) {
          return;
        }


        state.items.forEach(
          function (item) {

            item.style.height =
              Math.ceil(
                maxHeight
              ) +
              'px';
          }
        );


        state.wheel.style.height =
          Math.ceil(
            maxHeight + 54
          ) +
          'px';

      }
    );
  }


  function activate(state) {

    if (
      !state.shell ||
      !state.wheel ||
      state.items.length < 2
    ) {
      return;
    }


    state.active3D = true;


    state.root.classList.add(
      'sc-3d-active'
    );


    render(state);


    measure(state);


    setTimeout(
      function () {
        measure(state);
      },
      120
    );


    setTimeout(
      function () {
        measure(state);
      },
      450
    );
  }


  function deactivate(state) {

    state.active3D = false;


    state.root.classList.remove(
      'sc-3d-active',
      'sc-wheel-next',
      'sc-wheel-prev'
    );


    if (state.wheel) {

      state.wheel.style.height =
        '';
    }


    state.items.forEach(
      function (item) {

        item.style.height =
          '';


        removePositionClasses(
          item
        );


        item.removeAttribute(
          'aria-hidden'
        );

      }
    );
  }


  function applyMode(state) {

    refreshState(
      state.root
    );


    if (
      wheelEnabled(state.root) &&
      isMobile(state.root) &&
      state.items.length > 1
    ) {

      activate(state);

    }

    else {

      deactivate(state);

    }
  }


  /*
   * ==========================================================
   * ROUE INFINIE
   * ==========================================================
   */


  function move(
    state,
    direction
  ) {

    if (!state) {
      return;
    }


    refreshState(
      state.root
    );


    if (!state.active3D) {

      applyMode(state);
    }


    if (
      !state.active3D ||
      state.items.length < 2
    ) {
      return;
    }


    /*
     * Même si on clique vite,
     * on garde une roue réactive.
     */

    state.root.classList.remove(
      'sc-wheel-next',
      'sc-wheel-prev'
    );


    void state.root.offsetWidth;


    if (direction > 0) {

      state.root.classList.add(
        'sc-wheel-next'
      );

    }

    else {

      state.root.classList.add(
        'sc-wheel-prev'
      );

    }


    /*
     * MODULO =
     * DERNIER → PREMIER
     * PREMIER → DERNIER
     */

    state.active =
      modulo(
        state.active + direction,
        state.items.length
      );


    render(state);


    setTimeout(
      function () {

        state.root.classList.remove(
          'sc-wheel-next',
          'sc-wheel-prev'
        );


        measure(state);

      },
      610
    );
  }


  /*
   * ==========================================================
   * VARIANTES
   * ==========================================================
   */


  function selectVariant(button) {

    if (
      !button ||
      button.disabled
    ) {
      return;
    }


    var card =
      button.closest(
        '.sc-card'
      );


    if (!card) {
      return;
    }


    var buttons =
      arrayFrom(
        card.querySelectorAll(
          '[data-sc-option]'
        )
      );


    buttons.forEach(
      function (item) {

        item.classList.toggle(
          'is-selected',
          item === button
        );

      }
    );


    var input =
      card.querySelector(
        '[data-sc-variant-input]'
      );


    var price =
      card.querySelector(
        '[data-sc-price-current]'
      );


    var compare =
      card.querySelector(
        '[data-sc-price-compare]'
      );


    var variantId =
      button.getAttribute(
        'data-variant-id'
      );


    var priceValue =
      button.getAttribute(
        'data-price'
      );


    var compareValue =
      button.getAttribute(
        'data-compare-price'
      );


    var onSale =
      button.getAttribute(
        'data-sale'
      ) === 'true';


    if (input) {

      input.value =
        variantId;
    }


    if (price) {

      price.textContent =
        priceValue || '';
    }


    if (compare) {

      if (
        onSale &&
        compareValue
      ) {

        compare.textContent =
          compareValue;

        compare.hidden =
          false;

      }

      else {

        compare.textContent =
          '';

        compare.hidden =
          true;

      }

    }


    var root =
      card.closest(
        SELECTOR
      );


    if (root) {

      setTimeout(
        function () {

          measure(
            refreshState(root)
          );

        },
        20
      );
    }
  }


  function initializeVariants(root) {

    arrayFrom(
      root.querySelectorAll(
        '.sc-card'
      )
    ).forEach(
      function (card) {

        var input =
          card.querySelector(
            '[data-sc-variant-input]'
          );


        var buttons =
          arrayFrom(
            card.querySelectorAll(
              '[data-sc-option]'
            )
          );


        if (
          !input ||
          !buttons.length
        ) {
          return;
        }


        var selected =
          buttons.find(
            function (button) {

              return (
                !button.disabled &&
                button.getAttribute(
                  'data-variant-id'
                ) ===
                input.value
              );

            }
          );


        if (!selected) {

          selected =
            buttons.find(
              function (button) {

                return (
                  !button.disabled
                );

              }
            );
        }


        if (selected) {

          selectVariant(
            selected
          );
        }

      }
    );
  }


  /*
   * ==========================================================
   * SWIPE INFINI
   * ==========================================================
   */


  function bindSwipe(state) {

    if (
      !state.shell ||
      state.shell.__saintSwipeBound
    ) {
      return;
    }


    state.shell.__saintSwipeBound =
      true;


    state.shell.addEventListener(
      'pointerdown',
      function (event) {

        if (!state.active3D) {
          return;
        }


        if (
          event.target.closest(
            '[data-sc-option], .sc-add-button, .sc-arrow'
          )
        ) {
          return;
        }


        state.pointerId =
          event.pointerId;


        state.startX =
          event.clientX;


        state.startY =
          event.clientY;


        state.lastX =
          event.clientX;


        state.lastY =
          event.clientY;


        try {

          state.shell.setPointerCapture(
            event.pointerId
          );

        }

        catch (error) {}

      }
    );


    state.shell.addEventListener(
      'pointermove',
      function (event) {

        if (
          state.pointerId === null ||
          event.pointerId !==
          state.pointerId
        ) {
          return;
        }


        state.lastX =
          event.clientX;


        state.lastY =
          event.clientY;

      }
    );


    state.shell.addEventListener(
      'pointerup',
      function (event) {

        if (
          state.pointerId === null ||
          event.pointerId !==
          state.pointerId
        ) {
          return;
        }


        var deltaX =
          event.clientX -
          state.startX;


        var deltaY =
          event.clientY -
          state.startY;


        state.pointerId =
          null;


        /*
         * SWIPE GAUCHE
         */

        if (
          deltaX < -28 &&
          Math.abs(deltaX) >
          Math.abs(deltaY) * 1.1
        ) {

          move(
            state,
            1
          );

          return;
        }


        /*
         * SWIPE DROITE
         */

        if (
          deltaX > 28 &&
          Math.abs(deltaX) >
          Math.abs(deltaY) * 1.1
        ) {

          move(
            state,
            -1
          );

        }

      }
    );


    state.shell.addEventListener(
      'pointercancel',
      function () {

        state.pointerId =
          null;

      }
    );
  }


  /*
   * ==========================================================
   * MONTAGE SECTION
   * ==========================================================
   */


  function mount(root) {

    if (!root) {
      return;
    }


    var state =
      refreshState(root);


    initializeVariants(
      root
    );


    bindSwipe(
      state
    );


    /*
     * IMAGES
     */

    arrayFrom(
      root.querySelectorAll(
        'img'
      )
    ).forEach(
      function (image) {

        if (
          image.__saintLoadBound
        ) {
          return;
        }


        image.__saintLoadBound =
          true;


        if (!image.complete) {

          image.addEventListener(
            'load',
            function () {

              measure(
                refreshState(root)
              );

            }
          );

        }

      }
    );


    /*
     * RESPONSIVE
     */

    if (
      window.ResizeObserver &&
      !root.__saintResizeObserver
    ) {

      root.__saintResizeObserver =
        new ResizeObserver(
          function () {

            var current =
              refreshState(root);


            applyMode(
              current
            );


            if (
              current.active3D
            ) {

              measure(
                current
              );

            }

          }
        );


      root.__saintResizeObserver.observe(
        root
      );
    }


    applyMode(
      state
    );
  }


  function mountAll(scope) {

    var base =
      scope || document;


    if (
      base.matches &&
      base.matches(SELECTOR)
    ) {

      mount(base);
    }


    if (
      base.querySelectorAll
    ) {

      arrayFrom(
        base.querySelectorAll(
          SELECTOR
        )
      ).forEach(
        mount
      );
    }
  }


  /*
   * ==========================================================
   * CLICS GLOBAUX
   *
   * Très important pour plusieurs collections Shopify.
   * ==========================================================
   */


  document.addEventListener(
    'click',
    function (event) {


      /*
       * FLÈCHE SUIVANTE
       */

      var next =
        event.target.closest(
          '[data-sc-next]'
        );


      if (next) {

        var nextRoot =
          next.closest(
            SELECTOR
          );


        if (nextRoot) {

          event.preventDefault();

          event.stopPropagation();


          move(
            refreshState(
              nextRoot
            ),
            1
          );

        }


        return;
      }


      /*
       * FLÈCHE PRÉCÉDENTE
       */

      var previous =
        event.target.closest(
          '[data-sc-prev]'
        );


      if (previous) {

        var previousRoot =
          previous.closest(
            SELECTOR
          );


        if (previousRoot) {

          event.preventDefault();

          event.stopPropagation();


          move(
            refreshState(
              previousRoot
            ),
            -1
          );

        }


        return;
      }


      /*
       * VARIANTE
       */

      var option =
        event.target.closest(
          '[data-sc-option]'
        );


      if (option) {

        event.preventDefault();

        event.stopPropagation();


        selectVariant(
          option
        );


        return;
      }


      /*
       * CLIC CARTE LATÉRALE
       */

      var item =
        event.target.closest(
          '[data-sc-item]'
        );


      if (!item) {
        return;
      }


      var root =
        item.closest(
          SELECTOR
        );


      if (!root) {
        return;
      }


      var state =
        refreshState(root);


      if (!state.active3D) {
        return;
      }


      if (
        item.classList.contains(
          'sc-left'
        )
      ) {

        event.preventDefault();

        event.stopPropagation();


        move(
          state,
          -1
        );


        return;
      }


      if (
        item.classList.contains(
          'sc-right'
        )
      ) {

        event.preventDefault();

        event.stopPropagation();


        move(
          state,
          1
        );

      }

    },
    true
  );


  /*
   * ==========================================================
   * SHOPIFY EDITOR
   * ==========================================================
   */


  document.addEventListener(
    'shopify:section:load',
    function (event) {

      mountAll(
        event.target
      );

    }
  );


  document.addEventListener(
    'shopify:section:select',
    function (event) {

      mountAll(
        event.target
      );

    }
  );


  document.addEventListener(
    'shopify:block:select',
    function (event) {

      var root =
        event.target.closest
        ? event.target.closest(
            SELECTOR
          )
        : null;


      if (root) {

        mount(
          root
        );
      }

    }
  );


  /*
   * ==========================================================
   * MUTATION OBSERVER
   * Shopify remplace parfois les sections sans prévenir.
   * ==========================================================
   */


  if (window.MutationObserver) {

    var observer =
      new MutationObserver(
        function (mutations) {

          mutations.forEach(
            function (mutation) {

              if (
                mutation.type ===
                'childList'
              ) {

                arrayFrom(
                  mutation.addedNodes
                ).forEach(
                  function (node) {

                    if (
                      node.nodeType !== 1
                    ) {
                      return;
                    }


                    mountAll(
                      node
                    );

                  }
                );

              }


              if (
                mutation.type ===
                'attributes'
              ) {

                var target =
                  mutation.target;


                if (
                  target.matches &&
                  target.matches(
                    SELECTOR
                  )
                ) {

                  mount(
                    target
                  );

                }

              }

            }
          );

        }
      );


    observer.observe(
      document.documentElement,
      {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: [
          'data-mobile-3d'
        ]
      }
    );
  }


  /*
   * ==========================================================
   * RESIZE GLOBAL
   * ==========================================================
   */


  var resizeTimer = null;


  window.addEventListener(
    'resize',
    function () {

      clearTimeout(
        resizeTimer
      );


      resizeTimer =
        setTimeout(
          function () {

            mountAll(
              document
            );

          },
          120
        );

    }
  );


  /*
   * ==========================================================
   * INITIALISATION
   * ==========================================================
   */


  API.mount =
    mount;


  API.mountAll =
    mountAll;


  API.next =
    function (root) {

      move(
        refreshState(root),
        1
      );

    };


  API.prev =
    function (root) {

      move(
        refreshState(root),
        -1
      );

    };


  window.SaintCBDInfinite3D =
    API;


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        mountAll(
          document
        );

      }
    );

  }

  else {

    mountAll(
      document
    );

  }


  window.addEventListener(
    'load',
    function () {

      mountAll(
        document
      );

    }
  );

})();